<div id="spinner" class="container centerItem" style="text-align: center">
  <mat-spinner style="margin-left: auto; margin-right: auto" [mode]="'indeterminate'"></mat-spinner
  ><br *ngIf="this.mensaje != ''" />
  <p *ngIf="this.mensaje != ''">{{ this.mensaje }}</p>
</div>
